<template>
  <form class="ui-form mb-md-5" @submit.prevent>
    <div class="col-xl-6 col-md-12 col-sm-6 col-12 pl-0">
      <div class="signup__input-wrapper">
        <select id="event" v-model="picked_event" required>
          <option disabled selected>Selecione um evento para ver seus passaportes</option>
          <option :key="event" :value="event" v-for="event in items">
            {{ event }}
          </option>
        </select>
        <label for="event"> Escolha o evento* </label>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: ['items', 'first'],
  data() {
    return {
      width: screen.width,
      picked_event: this.first,
    }
  },
  watch: {
    picked_event() {
      this.changePassportsShownByYear(this.picked_event)
    },
  },
  methods: {
    changePassportsShownByYear(year) {
      const current_open_tab = document.getElementsByClassName('event_year_active')[0]
      if (current_open_tab) {
        current_open_tab.classList.remove('event_year_active')
        current_open_tab.classList.add('event_year_inactive')
      }
      const tab_to_open = document.getElementById(`${year}`)
      if (tab_to_open) {
        tab_to_open.classList.remove('event_year_inactive')
        tab_to_open.classList.add('event_year_active')
      }

      const current_clicked_tab = document.getElementsByClassName('passport_tabs')[0]
      if (current_clicked_tab) {
        current_clicked_tab.classList.remove('passport_tabs')
        current_clicked_tab.classList.add('passport_tabs_inactive')
      }
      const tab_just_clicked = document.getElementById(`tab-passports-${year}`)
      if (tab_just_clicked) {
        tab_just_clicked.classList.remove('passport_tabs_inactive')
        tab_just_clicked.classList.add('passport_tabs')
      }
    },
  },
}
</script>
